import { render, staticRenderFns } from "./PurchaseTemplateList.vue?vue&type=template&id=0eade312&scoped=true&"
import script from "./PurchaseTemplateList.vue?vue&type=script&lang=js&"
export * from "./PurchaseTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eade312",
  null
  
)

export default component.exports